var _circle, _circle2, _circle3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAreYouSureIcon = function SvgAreYouSureIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 200,
    viewBox: "0 0 243 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#FFF2F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 161.5,
    r: 38.5,
    fill: "#FFF2F3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.5,
    cy: 49.5,
    r: 21.5,
    fill: "#FFF2F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2064_16580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 63C94.9803 63 73 84.9803 73 112C73 139.02 94.9803 161 122 161C149.02 161 171 139.02 171 112C171 84.9803 149.02 63 122 63ZM122 140.583C119.746 140.583 117.917 138.754 117.917 136.5C117.917 134.246 119.746 132.417 122 132.417C124.254 132.417 126.083 134.246 126.083 136.5C126.083 138.754 124.254 140.583 122 140.583ZM128.464 114.621C127.018 115.287 126.083 116.745 126.083 118.334V120.167C126.083 122.42 124.258 124.25 122 124.25C119.742 124.25 117.917 122.42 117.917 120.167V118.334C117.917 113.568 120.718 109.199 125.042 107.202C129.203 105.287 132.208 100.203 132.208 97.7081C132.208 92.0818 127.631 87.5 122 87.5C116.369 87.5 111.792 92.0818 111.792 97.7081C111.792 99.9623 109.966 101.792 107.708 101.792C105.45 101.792 103.625 99.9623 103.625 97.7081C103.625 87.5778 111.869 79.3331 122 79.3331C132.131 79.3331 140.375 87.5778 140.375 97.7081C140.375 103.225 135.589 111.335 128.464 114.621Z",
    fill: "#FF5E6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2064_16580",
    x: 63,
    y: 57,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2064_16580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2064_16580",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAreYouSureIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/areYouSureIcon.0e540b3d785b4683cd618a8a6f54ef9a.svg";